import React from 'react'
import { Box, Grid } from '@mui/material'
import Invites from './Invites'
import ManageNetwork from './ManageNetwork'
import EventsSideBar from '../HomeProfile/EventsSideBar'
import SidebarUserList from '../HomeProfile/SidebarUserList'
// import SidebarUserList from './SidebarUserList'
// import PostBox from './PostBox'

const ConnectionsHome = () => {
  return (
    <Box 
    // sx={{ p: 2 }}
    >
      <Grid container spacing={2}>
        {/* Main Section */}
        {/* <Grid item md={8.5} xs={12} sm={12}> */}
        <Grid
          item
          size={{ md: 8.5, xs: 12, sm: 12 }}
        >
          <Invites />
        </Grid>

        {/* Side Content */}
        {/* <Grid item md={3.5} xs={12} sm={12}
         */}
        <Grid
          item
          size={{ md: 3.5, xs: 12, sm: 12 }}
          sx={{  height: "fit-content" }}>
          {/* <ManageNetwork /> */}
          <EventsSideBar />
          <SidebarUserList />
        </Grid>
      </Grid>
    </Box>
  )
}

export default ConnectionsHome
